import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { MultiSelect } from 'primeng/multiselect';
import { InputBaseComponent } from '../input-base/input-base.component';
import { merge, of } from 'rxjs';
import { InputDropdownItemModel } from '../input-dropdown/input-dropdown-item.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'input-multiselect',
  templateUrl: './input-multiselect.component.html',
  styleUrls: ['./input-multiselect.component.scss'],
  providers: [{ provide: InputBaseComponent, useExisting: forwardRef(() => InputMultiselectComponent) }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputMultiselectComponent extends InputBaseComponent implements OnInit, OnChanges {

  @ViewChild('dropdown') private elRef?: MultiSelect;

  @Input() public showToggleAll: boolean = false;
  @Input() public placeholder: string = '';
  @Input() public minItemsForFilter: number | false = 6;    // false = do not show filter
  @Input() public pleaseSelectLabel?: string;
  @Input() public items: InputDropdownItemModel<any, any>[] = [];
  @Input() public translateItems: boolean = true;
  @Input() public appendTo?: string;

  // PrimeNG 22 made dropdownIcon a signal input, so the open/closed icon is held here.
  public currentDropdownIcon: string = 'fa fa-fw fa-caret-down';
  public itemsForTemplate: InputDropdownItemModel<any, any>[] = [];
  public selectedItem?: InputDropdownItemModel<any, any> | null;

  constructor(private translateService: TranslateService) {
    super();
  }

  // TODO merge duplicate code with input-dropdown - helpermethod?
  public override ngOnInit(): void {
    super.ngOnInit();
    this.setItems();
    this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.setItems());
    // TODO fix for multiple values
    merge(of(this.control.value), this.change)
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe((val) => {
        this.selectedItem = this.items ? this.items.find((p) => p.value === val) : null;
      });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] || changes['includePleaseSelect']) {
      this.setItems();
    }
  }

  public openDropdown(event: Event): void { // TODO - not working - https://github.com/primefaces/primeng/blob/master/src/app/components/multiselect/multiselect.ts
    event.stopPropagation();
    if (this.elRef) {
      this.elRef.show();
    }
  }

  // TODO merge duplicate code with input-dropdown - helpermethod?
  private setItems(): void {
    // v18: translations moved behind getTranslations() and currentLang became a signal.
    const currentLang = this.translateService.currentLang();
    const translation = currentLang ? this.translateService.getTranslations(currentLang) as any : undefined;
    if (!translation) {
      return;
    }
    const items = this.translateItems
      ? this.items.map((i) => {
        const path = i.label.split('.').reverse();
        let part = path.pop() as string;
        let translatedLabel = translation[part];
        while (path.length && translatedLabel) {
          part = path.pop() as string;
          translatedLabel = translatedLabel[part];
        }
        return ({ value: i.value, label: translatedLabel ?? this.translateService.instant(i.label), disabled: !i.disabled ? false : i.disabled });
      })
      : this.items;

    if (this.pleaseSelectLabel?.length) {
      this.itemsForTemplate = [
        { value: null, label: this.pleaseSelectLabel, disabled: true },
        ...items
      ];
    }
    else {
      this.itemsForTemplate = items;
    }

  }

}
